export default class WindowIds {
  public static readonly MapId: string = "map";
  public static readonly TableId: string = "table";
  public static readonly TableOldId: string = "table_old";
  public static readonly LidarId: string = "lidar";

  public static getCameraId(cameraName: string): string {
    return "camera_" + cameraName;
  }

  public static getSummaryChartId(chartName: string): string {
    return "summaryChart_" + chartName;
  }

  public static getChartId(chartName: string): string {
    return "chart_" + chartName;
  }
}
